import { render, staticRenderFns } from "./BalanceMoneyStep3.vue?vue&type=template&id=288a9b1f&scoped=true"
import script from "./BalanceMoneyStep3.vue?vue&type=script&lang=js"
export * from "./BalanceMoneyStep3.vue?vue&type=script&lang=js"
import style0 from "./BalanceMoneyStep3.vue?vue&type=style&index=0&id=288a9b1f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288a9b1f",
  null
  
)

export default component.exports